module HearingLocationFactory {
	export function GetCitiesByState(state: States, successCallback: (Cities: string[]) => any, failureCallback: () => any)
	{
		const parameters = {
			state: state
		};
		$.ajax("/Api/SocialSecurity/HearingLocations/CitiesByState", {
			data: $.param(parameters),
			contentType: "application/json; charset=utf-8",
			dataType: "json",
			type: "GET",
			timeout: 5000,
			success: successCallback,
			error: failureCallback
		});
	}

	export function ByStateCity(state: States, city: string, successCallback: (HearingLocations: IHearingLocation[]) => any, failureCallback: () => any)
	{
		const parameters = {
			state: state,
			city: city
		};
		$.ajax("/Api/SocialSecurity/HearingLocations/ByCityState", {
			data: $.param(parameters),
			contentType: "application/json; charset=utf-8",
			dataType: "json",
			type: "GET",
			timeout: 5000,
			success: successCallback,
			error: failureCallback
		});
	}
}